export const Dictionary = {
  __generic_api_failure: "Etwas ist schief gelaufen.",
  __generic_api_error: "Ihre Anfrage kann derzeit nicht bearbeitet werden.",
  __invalid_token:
    "Ihre Anfrage kann nicht abgeschlossen werden, das Token ist ungültig. Das Sicherheitstoken ist möglicherweise abgelaufen oder wurde bereits verwendet.",
  __generic_api_403: "Sie haben keine Berechtigung, diese Aktion auszuführen.",
  __you_are_offline: "Sie sind nicht mit dem Internet verbunden.",
  __coming_soon:
    "Diese Funktion wird derzeit entwickelt und ist bald verfügbar.",
};
